var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { IS_DEMO } from '@web/config';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
function labelMatchesTargets(label, labelTargets) {
    return labelTargets.some(function (target) {
        return label.rules.some(function (rule) { return rule.target === target; });
    });
}
export function ActivityLabelFilterSelect(_a) {
    var _b;
    var labelTargets = _a.labelTargets;
    var labels = useWorkspaceCtx().labels;
    var filters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var defaultOption = {
        id: null,
        name: '-'
    };
    var visibleLabels = IS_DEMO
        ? labels
        : labels.filter(function (label) { return labelMatchesTargets(label, labelTargets); });
    var labelsOptions = visibleLabels.map(function (label) { return ({
        id: label.id,
        name: label.name
    }); });
    var selectedLabel = (_b = labelsOptions.find(function (label) { return label.id === filters.activityLabel; })) !== null && _b !== void 0 ? _b : (filters.activityLabel != null
        ? labels
            .filter(function (label) { return label.id === filters.activityLabel; })
            .map(function (label) { return ({ id: label.id, name: label.name }); })[0]
        : undefined);
    function onChange(newOption) {
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                activityLabel: newOption.id === null ? null : Number(newOption.id)
            }
        });
    }
    return (_jsx(Select, { label: t('filters.activityLabels'), selected: selectedLabel !== null && selectedLabel !== void 0 ? selectedLabel : defaultOption, options: __spreadArray([defaultOption], labelsOptions, true), onChange: onChange, withSearchField: true }));
}
